import { render, staticRenderFns } from "./HeroSlider.vue?vue&type=template&id=b2b82298&scoped=true"
import script from "./HeroSlider.vue?vue&type=script&lang=js"
export * from "./HeroSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b82298",
  null
  
)

export default component.exports